import { MANIFESTO } from "@/data";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading id="manifesto" overline="Manifesto / 04" title="Three rules I work by" />
        <div className="space-y-2">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.num} delay={i * 0.1}>
              <div
                data-testid={`manifesto-chapter-${m.num}`}
                className="group grid sm:grid-cols-12 gap-4 sm:gap-8 items-baseline py-10 border-t border-white/10 last:border-b hover:bg-white/[0.03] transition-colors duration-500 px-2 sm:px-4 rounded-lg"
              >
                <span className="sm:col-span-3 font-editorial italic text-5xl sm:text-6xl text-white/10 group-hover:text-[#D9A441]/50 transition-colors duration-500">
                  {m.num}
                </span>
                <h3 className="sm:col-span-4 font-display text-xl sm:text-2xl font-semibold tracking-tight text-[#F3EFE6]">
                  {m.title}
                </h3>
                <p className="sm:col-span-5 text-[#9DAEC4] text-base leading-relaxed">{m.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
